import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { StationeryRequestService } from "../../../../../services/company-office/StationeryRequest.service";

export const useGetMyRequests = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["stationery-request-my-requests", currentUserName],
    queryFn: () => StationeryRequestService.getMyStationeryRequests(currentUserName),
    refetchOnMount: "always",
  });

  return response;
};
